import React from "react";

import { Hero } from "../Hero";
import { Banner } from "@/components/Banner";
import { BannerWrapperSize } from "@/components/Banner/types";
import { billboardProps } from "@/data/types/home";

export const HeroModule = ({
  data,
  wrapperSize,
}: {
  data: billboardProps;
  wrapperSize: BannerWrapperSize;
}) => {
  const { ctaLabel, ctaLink, richtext, data_qa, backgroundColor, ctaStyle, twoColumns } = data;

  return (
    <Banner
      medium
      light
      customBgColor={backgroundColor}
      wrapperSize={wrapperSize}
    >
      <Hero
        priority
        heroText={richtext}
        cta={{
          ctaLink,
          ctaLabel,
          data_qa,
          ctaStyle,
        }}
        twoColumns={twoColumns}
        img={"/images/hero-banner.png"}
        //size="(max-width: 768px) 360px, (max-width: 1280px) 50vw, 33vw"
        size="(max-width: 480px) 256px, (max-width: 768px) 360px, 50vw"
        quality={65}
      />
    </Banner>
  );
};
